<script setup>
import { SOCIAL_SHARE_IMAGE, usePageHead } from '@composables/use-page-head'
import { computed, onMounted, ref, watch } from 'vue'
import { usePlaybackStore } from '@state/stores/playback'
import DataLayer from '@services/data-layer/index'
import MixGridBlock from '@components/mix-grid-block'

const playbackStore = usePlaybackStore()

const mixes = ref([])

const recentlyPlayedMixes = computed(() => {
    const history = playbackStore && playbackStore.history

    return (
        history &&
        history.reduce((unique, id) => (unique.includes(id) ? unique : [...unique, id]), [])
    )
})

function getMixes() {
    const ids = recentlyPlayedMixes.value

    if (!ids || !ids.length) return

    Promise.all(ids.map(id => DataLayer.mixes.getById(id))).then(responses => {
        mixes.value = responses.map(response => response.body)
    })
}

watch(recentlyPlayedMixes, getMixes)

onMounted(getMixes)

usePageHead({
    title: 'Recently Played',
    description: 'Recently played DJ mixes on FRISKY.',
    image: SOCIAL_SHARE_IMAGE,
})
</script>

<template>
    <BaseSection
        v-if="mixes && mixes.length"
        padded
    >
        <MixGridBlock :mixes="mixes" />
    </BaseSection>
</template>
